export default {
  bone: ({ btn }) => ({
    display: btn ? 'block' : 'inline-block',
    height: btn ? '40px' : '14px',
    width: '100%',
    backgroundColor: '#f3f3f3',
    borderRadius: btn ? '4px' : '30px',
    background: 'linear-gradient(-90deg, #ececec 0%, #fff 50%, #ececec 100%)',
    backgroundSize: '400% 400%',
    animation: 'pulse 1.2s ease-in-out infinite'
  }),
  '@keyframes pulse': {
    '0%': {
      backgroundPosition: '0% 0%'
    },
    '100%': {
      backgroundPosition: '-135% 0%'
    }
  }
}
